import { useState, useEffect } from "react";
import { DEFAULT_VALUE_OPTION, instance1 } from "App/constants";
import { defaultToastError } from "App/utils/helpers";

const getAllLayanan = async (url) => {
  try {
    const api = await instance1.get(url);
    const res = api.data;
    return res.body;
  } catch (error) {
    defaultToastError(error?.response?.data?.message);
    return false;
  }
};

const useInitialLayanan = (
  useId,
  withSearch = false,
  url = "/layanan/listlayanan"
) => {
  const DEFAULT_OPTION = withSearch ? [] : DEFAULT_VALUE_OPTION("Layanan");

  const [state, setState] = useState(DEFAULT_OPTION);
  useEffect(() => {
    (async () => {
      const res = await getAllLayanan(url);

      if (res) {
        const data = withSearch
          ? []
          : [
              {
                value: 0,
                label: "Pilih Layanan",
              },
            ];
        if (useId) {
          res.map((item) => {
            return data.push({
              value: item.id,
              label: item.name,
            });
          });
        } else {
          res.map((item) => {
            return data.push({
              value: item.code,
              label: item.name,
            });
          });
        }
        setState(data);
      }
    })();
  }, [useId, withSearch, url]);

  return state;
};

export default useInitialLayanan;
